export function customSelect() {
    // Options for custom Select
    jcf.setOptions("Select", {
        wrapNative: false,
        wrapNativeOnMobile: false,
        fakeDropInBody: false,
        maxVisibleItems: 4
    });
    jcf.replaceAll();
};


// WEBPACK FOOTER //
// ./assets/js/modules/custom-select.js